import axios from 'axios';

import { API_ENDPOINTS } from 'src/shared/constants';
import { ContactForm } from 'src/shared/models';

export const addContactForm = async (dataForm: ContactForm) => {
	const { data } = await axios.post(API_ENDPOINTS.CONTACT_MESSAGES.POST, dataForm);
	return data;
};
